import { createReducer } from "./functions";

import { CLIENTS_SET_LIST } from "../types";

const initialState = {
  clientsList: [],
  page: 0,
  pages: 0,
  pageSize: 10
};

const setClientsList = {
  [CLIENTS_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page") ? action.payload.page : state.page;
    const pages = action.payload.hasOwnProperty("pages") ? action.payload.pages : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages) hasNext = false;
    return { ...state, clientsList: action.payload.docs, page, pages, hasNext };
  }
};
const clientsReducer = createReducer(initialState, {
  ...setClientsList
});

export default clientsReducer;



// WEBPACK FOOTER //
// src/redux/reducers/clientsReducer.js